export default {
    getAllIssues: (page, assigneeIds, groupId) => {
        return {
            url: `/groups/:groupId/issues?per_page=100&page=:page`,
            method: 'GET',
            route_params: {
                groupId,
                page
            }
        };
    },
    getIssue: (projectId, issueId) => {
        return {
            url: '/projects/:projectId/issues/:issueId',
            method: 'GET',
            route_params: {
                projectId,
                issueId
            }
        };
    },
    updateIssue: (projectId, issueId, formIssue) => {
        return {
            url: '/projects/:projectId/issues/:issueId',
            method: 'PUT',
            route_params: {
                projectId,
                issueId
            },
            put_params: {
                description: formIssue.description,
                title: formIssue.title
            }
        };
    },
    createIssue: (formIssue, assigneeIds) => {
        return {
            url: '/projects/:projectId/issues',
            method: 'POST',
            route_params: {
                projectId: formIssue.project_id
            },
            post_params: {
                description: formIssue.description === null ? '' : formIssue.description,
                title: formIssue.title,
                assignee_ids: assigneeIds
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/Issues/api.js